import FormErrors from './errors';

export default class VueForm {
  constructor(data) {
    this.data = data;
    this.errors = new FormErrors();
    this.busy = false;
    this.successful = false;
  }

  startProcessing() {
    this.errors.forget();
    this.busy = true;
    this.successful = false;
  };

  finishProcessing() {
    this.busy = false;
    this.successful = true;
  };

  resetStatus() {
    this.errors.forget();
    this.busy = false;
    this.successful = false;
  };

  setErrors(errors) {
    this.busy = false;
    this.errors.set(errors);
  };

  post(uri, config = {}) {
    return this.sendForm({method: 'post', uri, data: this.data, config})
  }

  put(uri, config = {}) {
    return this.sendForm({method: 'put', uri, data: this.data, config})
  }

  sendForm({method, uri, config, data}) {
    return new Promise((resolve, reject) => {
      this.startProcessing();

      // Ensure we have a fresh CSRF token before making the request
      this.ensureFreshCsrfToken().then(() => {
        window.axios[method](uri, data, config)
          .then(response => {
            this.finishProcessing();

            resolve(response.data);
          })
          .catch(errors => {
            // If CSRF token mismatch, try once more with fresh token
            if (errors.response && errors.response.status === 419) {
              this.refreshCsrfToken().then(() => {
                window.axios[method](uri, data, config)
                  .then(response => {
                    this.finishProcessing();
                    resolve(response.data);
                  })
                  .catch(retryErrors => {
                    this.setErrors(retryErrors.response.data.errors);
                    reject(retryErrors.response.data);
                  });
              }).catch(() => {
                this.setErrors(errors.response.data.errors);
                reject(errors.response.data);
              });
            } else {
              this.setErrors(errors.response.data.errors);
              reject(errors.response.data);
            }
          });
      }).catch(() => {
        this.busy = false;
        reject({ message: 'Failed to obtain CSRF token' });
      });
    });
  }

  /**
   * Ensure we have a fresh CSRF token
   */
  ensureFreshCsrfToken() {
    return new Promise((resolve) => {
      const token = document.head.querySelector('meta[name="csrf-token"]');
      if (token && token.content) {
        // Update axios header with current token
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
        resolve();
      } else {
        // No token found, fetch a fresh one
        this.refreshCsrfToken().then(resolve).catch(resolve);
      }
    });
  }

  /**
   * Fetch a fresh CSRF token from the server
   */
  refreshCsrfToken() {
    return new Promise((resolve, reject) => {
      // Make a simple GET request to get fresh CSRF token
      window.axios.get('/csrf-token')
        .then(response => {
          if (response.data.token) {
            // Update the meta tag
            let tokenMeta = document.head.querySelector('meta[name="csrf-token"]');
            if (!tokenMeta) {
              tokenMeta = document.createElement('meta');
              tokenMeta.name = 'csrf-token';
              document.head.appendChild(tokenMeta);
            }
            tokenMeta.content = response.data.token;
            
            // Update axios header
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.token;
            resolve();
          } else {
            reject();
          }
        })
        .catch(() => {
          // Fallback: try to get token from current page
          window.location.reload();
        });
    });
  }
};
